<template>
    <!-- top 보라 -->
    <v-snackbar
      v-if="position === 'top'"
      v-model="toast"
      top
      elevation = "0"
      :timeout="3000"
      class="toast-primary"
    >
      {{ text }}
    </v-snackbar>
    <!-- bottom 블랙, 버튼 존재 -->
    <v-snackbar v-else
      v-model="toast"
      bottom
      elevation = "0"
      :timeout="-1"
      v-click-outside="e => onClickOutside(e)"
    >
      <div class="d-flex justify-space-between" @click.prevent="[$emit('snackbarClick',goUrl)]">
        {{ text }}
        <span class="primary--text" v-if="goUrlText">{{ goUrlText }}<i class="ez-dms-arr-right-md ms-2"></i></span>
      </div>
<!--      <div @click="[$emit('snackbarClick',goUrl)]">{{ text }}</div>-->
      <template v-slot:action="{ attrs }">
        <v-btn
            v-if="!goUrlText"
          icon
          v-bind="attrs"
          @click="toastClose"
        >
          <img :src="getImage('ic_toast_close.svg')">
        </v-btn>
      </template>
    </v-snackbar>
</template>
<script>
  import VueCookies from "vue-cookies";
  export default {
    data: () => ({
      position: 'top',
      toast:false,
      text:'',
      cookie:'',
      goUrl: '',
      goUrlText: null
    }),
    methods:{
      onClickOutside () {
        // 이벤트 팝업 우선 순위 부여
        const el = document.querySelector('#modalEvent')
        if (el) {
          const elDisplay = el.parentElement.style.display === 'none'
          if (el && elDisplay) this.toastClose()
          return
        }
        this.toastClose()
      },
      /* flag: top/bottom */
      toastOpen(flag,text,cookie,goUrl, goUrlText = null){
        this.cookie =cookie;
        this.goUrl = goUrl;
        this.goUrlText = goUrlText;
        if(this.cookie != null && this.cookie != ''){
          if (!VueCookies.isKey(this.cookie)) {
            this.toast = true;
            this.position = flag;
            this.text = text;
          }
        } else {
          this.toast = true;
          this.position = flag;
          this.text = text;
        }
      },
      toastClose(){
        // sr-15728 : toast 닫히고, 재진입 시 다시 노출되도록 변경됨 -> 닫힌 후, 하루동안 다시 뜨지 않도록 처리하려면 주석 풀면됨
        // if(this.cookie != null && this.cookie != ''){
        //   VueCookies.set(this.cookie,this.cookie,'1d');
        // }
        this.toast = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
/* alert */
.bottom-menu {
  & ~ .v-snack::v-deep {
    &:not(.v-snack--absolute) {
      height: calc(100vh - 100px - 56px - var(--system-bar-height));
      top: calc(56px + var(--system-bar-height)) !important;
      bottom: 100px !important;
    }
  }
}
::v-deep.v-snack{
    //bottom: 80px;
  &:not(.v-snack--absolute) {
    height: calc(100vh - 56px - var(--system-bar-height) - var(--system-bottom-height));
    top: calc(56px + var(--system-bar-height)) !important;
    bottom: var(--system-bottom-height) !important;
  }
    .v-snack__wrapper{
        background: rgba(0,0,0,.83);
        border-radius: 6px;
        .v-snack__content{
            color:#fff;
            text-align: center;
            text-shadow: 0px 2px 3px rgba(0,0,0,.22);
        }
    }
  &.toast-primary{
    .v-snack__wrapper{
      background: rgba(114,96,288,.9);
    }
  }
}

</style>
